// Import necessary functions from Redux Toolkit
import { configureStore } from '@reduxjs/toolkit';
// Import reducers for profiles and filters
import profilesReducer from './profilesSlice';
import filtersReducer from './filtersSlice';
import usersReducer from './usersSlice';
import animationReducer from './animationSlice'; 
import conversationsReducer from './conversationsSlice'; 
import appelOffreReducer from './appeloffreSlice'; 
import candidatureReducer from './candidatureSlice';

// Configure and create the Redux store
export const store = configureStore({
  reducer: {
    profiles: profilesReducer,
    filters: filtersReducer,
    users: usersReducer,
    animation: animationReducer,
    conversations: conversationsReducer,
    appelOffres: appelOffreReducer, 
    candidatures: candidatureReducer,
  },
});

export default store;
